/**
 * 네이티브 헤더(StackScreen)를 노출할 WebView 경로 화이트리스트.
 *
 * WebViewScreen 은 기본적으로 헤더를 숨기고(=웹뷰가 전체 화면), 아래 목록에
 * 해당하는 pathname 으로 진입한 경우에만 네이티브 헤더를 그린다.
 *
 * pathname 의 prefix(startsWith) 매칭이므로 하위 경로까지 포함된다.
 * (예: '/agreement' → '/agreement/terms-of-use', '/agreement/privacy')
 */
const HEADER_VISIBLE_PATH_PREFIXES: readonly string[] = [
  '/agreement', // 이용약관 / 개인정보 처리방침
  '/events', // 청소년 보호정책
];

/**
 * 주어진 url 이 헤더를 노출해야 하는 경로인지 판단.
 * 파싱 실패하거나 목록에 없으면 false(=헤더 숨김)가 기본값.
 */
export const shouldShowNativeHeader = (url: string | undefined): boolean => {
  if (url == null) return false;
  try {
    const { pathname } = new URL(url);
    return HEADER_VISIBLE_PATH_PREFIXES.some(prefix =>
      pathname.startsWith(prefix),
    );
  } catch {
    return false;
  }
};
